import { User } from 'containers/user/types/user'
import { NotificationDTO, NotificationTypes } from '../types/notifications'
import { NotificationCreationProject } from './notifications-types/creation-project'
import { NotificationCreationHighlight } from './notifications-types/highlight-creation'
import { LikeNotification } from './notifications-types/like-notification/LikeNotification'

interface NotificationItemProps {
  notification: NotificationDTO
  onRequestConnection?: (profile: User) => void
}

export const NotificationItem = ({ notification, onRequestConnection }: NotificationItemProps) => {
  switch (notification.notificationType) {
    case NotificationTypes.LIKE:
      return <LikeNotification notification={notification} onRequestConnection={onRequestConnection} />
    case NotificationTypes.NETWORK_PROJECT_CREATED:
      return <NotificationCreationProject notification={notification} />
    case NotificationTypes.NETWORK_HIGHLIGHT_CREATED:
      return <NotificationCreationHighlight notification={notification} />
    default:
      return null
  }
}
